module.exports = __webpack_public_path__ + "static/img/pic-faq4.333278f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-faq4.png
// module id = 932
// module chunks = 0